import { Chip, type SxProps, type Theme } from '@mui/material';

export type IncompleteBadgeProps = {
    /** Texte du badge, déjà traduit par l'appelant. */
    label: string;
    'data-testid'?: string;
    sx?: SxProps<Theme>;
};

/**
 * Marqueur « Données incomplètes » sur une card ou une ligne de listing.
 *
 * Piloté par la donnée (`isIncomplete`), il n'apparaît que pour le DMC
 * propriétaire sur son propre listing : les autres rôles ne reçoivent jamais
 * d'item incomplet, et la fiche DMC les pré-filtre — d'où l'absence de badge
 * sur la fiche.
 *
 * `warning` en `outlined` : l'item reste consultable, ce n'est pas une erreur
 * mais un travail à finir.
 */
export function IncompleteBadge({ label, 'data-testid': dataTestId, sx }: IncompleteBadgeProps) {
    return (
        <Chip
            label={label}
            color="warning"
            size="small"
            variant="outlined"
            data-testid={dataTestId}
            sx={sx}
        />
    );
}
